if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super({
        name: "Sticky ATC",
        version: "2.1.0",
      });
    }

    connectedCallback() {
      this.button = this.querySelector("[data-sticky-atc-btn]");
      this.colorSelector = this.querySelector(".product__color-selector");
      this.variantSelector = this.querySelector(".product__variant-selector");

      document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight}px`);

      // Always show the sticky ATC
      this.style.transform = "translateY(0)";

      this.colorSelectorDrawerListener();
      this.variantSelectorListener();

      this.button.addEventListener("click", this.onClickHandler.bind(this));

      this.mobileButton = this.querySelector(".mobile-trigger button");
      this.mobileButton?.addEventListener("click", this.onClickHandlerMobile.bind(this));
    }

    colorSelectorDrawerListener() {
      this.colorSelector?.querySelector(".product__color-selector--wrapper").addEventListener("click", () => {
        this.colorSelector.classList.toggle("active");
        this.variantSelector?.classList.remove("active");
      });
    }

    variantSelectorListener() {
      this.variantSelector?.querySelector(".product__variant-selector--wrapper").addEventListener("click", () => {
        this.variantSelector.classList.toggle("active");
        this.colorSelector?.classList.remove("active");
      });
    }

    onClickHandler(event) {
      event.preventDefault();
      var mainAtc = document.querySelector("product-form .product-form__submit");
      if (mainAtc) {
        mainAtc.click();
      }
    }

    onClickHandlerMobile(event) {
      event.preventDefault();
      // Scroll to top on mobile devices
      if (window.innerWidth < 750) {
        window.scroll({ top: 0, behavior: "smooth" });
      }
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
